import { render, staticRenderFns } from "./sup-wallet.vue?vue&type=template&id=56ac545c"
import script from "./sup-wallet.vue?vue&type=script&lang=js"
export * from "./sup-wallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports